import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            今日最受关注的五大热门话题
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              } cursor-pointer hover:bg-background-50/60 transition-colors`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-background-200 text-foreground-600 font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-primary-500 text-xs"></i>
                  )}
                  {item.trend === 'down' && (
                    <i className="ri-arrow-down-line text-secondary-500 text-xs"></i>
                  )}
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
              </div>
              <div className="text-sm font-bold text-primary-500 whitespace-nowrap flex-shrink-0">
                {item.heat}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}